import React, { Component } from 'react'
import { Route, Switch }    from 'react-router-dom'
import Status404            from '../Status404'
import List                 from './List'
import Detail               from './Detail'

class College extends Component {
  render() {
    const { match } = this.props
    return (
      <Switch>
        <Route path={`${match.url}/list`} component={List}></Route>
        <Route path={`${match.url}/detail/:id`} component={Detail}></Route>
        <Route component={Status404}></Route>
      </Switch>
    )
  }
}

export default College



// WEBPACK FOOTER //
// ./src/pages/Profession/index.js